import React, { useRef } from 'react';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import classes from '../../category-description.scss';
export default function Arrow({
  isShown,
  onClick
}) {
  const inputRef = useRef(null);
  const handleKeyDown = event => {
    handleOnEnterPressed(event, onClick);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  return isShown ? /*#__PURE__*/React.createElement("div", {
    className: classes.iconWrapper,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    tabIndex: 0,
    ref: inputRef,
    "aria-label": "Close category description"
  }, /*#__PURE__*/React.createElement(ArrowDropUpIcon, {
    className: classes.selectIcon,
    fontSize: "large",
    focusable: true
  })) : /*#__PURE__*/React.createElement("div", {
    className: classes.iconWrapper,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    tabIndex: 0,
    ref: inputRef,
    "aria-label": "Open category description"
  }, /*#__PURE__*/React.createElement(ArrowDropDownIcon, {
    className: classes.selectIcon,
    fontSize: "large",
    focusable: true
  }));
}